import axiosInterceptor from "shared/utils/axios-interceptor";

export const getCampaignInfoByLink = (Link) => {
	return axiosInterceptor
		.get(`/campaign-links/link/${Link}`)
		.then((response) => response.data);
};
